/**
 * Which length a hand-typed slot is held to, as the plan detail sends it to the slots card. The
 * server decides it in `call-length.ts`; this module holds only the shape, so the page can read it
 * without the server's file access.
 */
import { z } from "zod";
import { contextValueSchemas } from "../../../skills/leadcue-reply/scripts/lib/context-contracts.ts";

export const CallLengthSchema = z.discriminatedUnion("kind", [
  /**
   * The length is known. `conversation`: the rep answered it on this conversation's card. `saved`:
   * the run read it from the answers already saved, for the campaign or the workspace.
   */
  z.strictObject({
    kind: z.literal("known"),
    minutes: contextValueSchemas.meeting_duration_minutes,
    source: z.enum(["conversation", "saved"]),
  }),
  /** This conversation asks how long the call is and nobody has answered: that comes first. */
  z.strictObject({ kind: z.literal("asked") }),
  /** No length anywhere, or the rep chose not to state one: the card asks for one for its slots. */
  z.strictObject({ kind: z.literal("choose") }),
]);
export type CallLength = z.infer<typeof CallLengthSchema>;
